import { FormattedMessage } from 'react-intl'
import InclusionsTable from './InclusionsTable'
import InclusionRow from './InclusionRow'
import { Fragment, useState } from 'react'
import InsurancePopup from './InsurancePopup'

export default function InsuranceSection({ fields }) {
  const [isVisible, setVisible] = useState(false)
  const closePopup = () => setVisible(false)
  const showInsurancePopup = () => setVisible(true)
  return (
    <Fragment>
      <InsurancePopup isVisible={isVisible} onClose={closePopup} />
      {fields.map((_, index) => {
        const value = fields.value[index]
        return (
          <div className='inclusions-section' key={value.pricingId}>
            <h3 className='section-title'>
              <i className='icon font-icons icon-insurance' />
              <FormattedMessage
                id='dan'
                defaultMessage='Dive Accident Insurance'
              />
            </h3>
            <InclusionsTable>
              <InclusionRow
                name={`insurances[${index}]`}
                item={value}
                showDetailsPopup={showInsurancePopup}
              />
            </InclusionsTable>
          </div>
        )
      })}
    </Fragment>
  )
}
